<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
            fxLayout="column" fxLayoutAlign="center center"
            fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÃO -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
            <!-- APP TITLE -->
            <div class="logo"
                    fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Tipo de Receita
                </span>
                
                <!-- BOTÃO ADICIONAR (mini-fab) -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Novo Tipo de Receita"
                        (click)="openCadastro()"
                        style="margin-left: 16px;">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            </div>
        </div>

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [rows]='rows'>

                <ngx-datatable-column name="Nome" prop="descricao" [sortable]="false" [width]="400">
                    <ng-template let-rowIndex="rowIndex" let-descricao="value" ngx-datatable-cell-template>
                        {{ descricao }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Alterar Ação" (click)="openAlterar(id)">
                            <mat-icon aria-label="Editar Ação">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Ação" (click)="delete(id)">
                            <mat-icon aria-label="Excluir Ação">delete</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>